import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';

import Header from "../../../../components/layout/Header";
import Wrapper from "../../../../components/layout/Wrapper";
import Footer from "../../../../components/layout/Footer";
import Breadcrumb from "../../../../components/layout/Breadcrumb";
import AccountSidebar from "../../AccountSidebar";
import {useAuth} from "../../../../context/AuthProvider";
import PageTitle from "../../../../components/layout/PageTitle";

import CheatSheetCard from "../../../../components/cards/CheatSheetCard";
import {COURSE_API_BASE} from "../../../../utils/apiConfig";

const CheatSheetMain = () => {

    const {course_id} = useParams();

    const {user} = useAuth();

    const [cheatsheets, setCheatsheets] = useState([]);
    const [loading, setLoading] = useState(true);

    const breadC = [
        {title: 'حساب‌کاربری', link: '#'},
        {title: 'دوره‌های من', link: '/fa/account/course'},
        {
            title: `${course_id}`,
            link: `/fa/account/course/${course_id}`
        },
        {
            title: 'تقلب‌نامه',
            link: `/fa/account/course/${course_id}/cheatsheet`
        },
    ];

    useEffect(() => {
        fetchCheatsheets();
    }, [course_id]);

    const fetchCheatsheets = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${COURSE_API_BASE}/${user.id}/courses/${course_id}/cheatsheets/`,
                {
                    withCredentials: true
                }
            );

            if (response.data.success) {
                setCheatsheets(response.data.cheatsheets || []);
            }

        } catch (error) {
            console.error('Failed to fetch cheatsheets:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col">

            <Header/>

            <main className="flex-1 my-8">

                <Wrapper>

                    <div className="w-full flex flex-1 gap-x-10">

                        {user && (
                            <AccountSidebar
                                name={user.name}
                                phone_number={user.phone_number}
                                credit={user.credit}
                                streak={user.streak}
                                xp={user.xp}
                                character={user.character}
                            />
                        )}

                        <div className="w-4/5">

                            <Breadcrumb
                                items={breadC}
                                wrapper={false}
                            />

                            <PageTitle
                                title={`تقلب‌نامه‌ی ${course_id}`}
                            />

                            {loading ? (
                                <div className="py-10 text-center text-gray-500">
                                    در حال بارگذاری...
                                </div>
                            ) : cheatsheets.length === 0 ? (
                                <div className="bg-gray-100 rounded-xl p-8 text-center text-gray-500">
                                    هنوز تقلب‌نامه‌ای برای این دوره وجود ندارد.
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-6">

                                    {cheatsheets.map((cheatsheet) => (
                                        <CheatSheetCard
                                            key={cheatsheet.id}
                                            cheatsheet={cheatsheet}
                                            courseId={course_id}
                                        />
                                    ))}

                                </div>
                            )}

                        </div>

                    </div>

                </Wrapper>

            </main>

            <Footer/>

        </div>
    );
};

export default CheatSheetMain;